import { takeLatest, all } from 'redux-saga/effects';
import {
  CHECK_MOBILE,
  CITY_FOR_ZIP_CODE,
  EDIT_PROFILE,
  FETCH_COUNTRIES,
  FETCH_CURRENT_COUNTRY,
  FETCH_DOMAIN_DETAILS,
  FETCH_LISTINGS,
  FETCH_PROFILE,
  FETCH_QUALIFICATIONS,
  FETCH_SPECIALITIES,
  LOGOUT_REQUEST,
  REGISTER_USER,
  SEND_OTP,
  UPDATE_MOBILE,
  VERIFY_EMAIL,
  VERIFY_OTP,
} from '../actions/types';
import { checkMobile, logoutUser, registerUser, sendOtp, updateMobile, verifyEmail, verifyOTP } from './authentications';
import { fetchCountries, fetchDomainDetails, fetchListings, fetchQualifications, fetchSpecialities } from './listings';
import { fetchCurrentCountry } from './utilities';
import { editProfile, fetchProfile, cityForZipCode } from './profile';

export default function* sagas() {
  yield all([
    takeLatest(CHECK_MOBILE, checkMobile),
    takeLatest(SEND_OTP, sendOtp),
    takeLatest(VERIFY_EMAIL, verifyEmail),
    takeLatest(VERIFY_OTP, verifyOTP),
    takeLatest(LOGOUT_REQUEST, logoutUser),
    takeLatest(FETCH_LISTINGS, fetchListings),
    takeLatest(FETCH_SPECIALITIES, fetchSpecialities),
    takeLatest(FETCH_QUALIFICATIONS, fetchQualifications),
    takeLatest(FETCH_CURRENT_COUNTRY, fetchCurrentCountry),
    takeLatest(FETCH_COUNTRIES, fetchCountries),
    takeLatest(REGISTER_USER, registerUser),
    takeLatest(UPDATE_MOBILE, updateMobile),
    takeLatest(CITY_FOR_ZIP_CODE, cityForZipCode),
    takeLatest(FETCH_PROFILE, fetchProfile),
    takeLatest(EDIT_PROFILE, editProfile),
    takeLatest(FETCH_DOMAIN_DETAILS, fetchDomainDetails),
  ]);
}
